import Component from "@glimmer/component"
import styles from "./print-button.module.css"

export default class PlannerButtonsPrintButtonComponent extends Component {
  readonly styles = styles
}
